import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

// Register service worker
const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('New content available. Reload?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Unread dot in favicon based on a global setter updated by NotificationCenter
(function setupFaviconUnread() {
  let baseHref = '/vite.svg';
  const link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
  if (link) {
    const href = link.getAttribute('href');
    if (href) baseHref = href;
  }

  const setUnread = (unread: number) => {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = 64; canvas.height = 64;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        ctx.clearRect(0, 0, 64, 64);
        ctx.drawImage(img, 0, 0, 64, 64);
        if (unread > 0) {
          ctx.fillStyle = '#ef4444';
          ctx.beginPath();
          ctx.arc(52, 12, 10, 0, Math.PI * 2);
          ctx.fill();
        }
        const url = canvas.toDataURL('image/png');
        const l = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
        if (l) l.href = url;
      };
      img.src = baseHref;
    } catch {}
  };
  (window as any).__setFaviconUnread = setUnread;
})();